import React, { useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleIndex = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

 const faqs = [
  {
    question: "What services does ZajraGreen offer?",
    answer:
      "ZajraGreen specializes in sports infrastructure solutions including football turf construction, box cricket arenas, multi-sport courts, and customized artificial grass installations.",
  },
  {
    question: "How can I get a quotation or start a project?",
    answer:
      "You can contact us through our website, phone, or WhatsApp. Share your location, ground size, and sport requirement, and our team will assist you with a site visit and quotation.",
  },
  {
    question: "Which areas do you serve?",
    answer:
      "We currently operate across Noida, Greater Noida, Delhi NCR, Ghaziabad, and nearby regions. Projects outside these areas can also be discussed.",
  },
  {
    question: "Do you handle end-to-end construction?",
    answer:
      "Yes. From site inspection, base work, drainage, turf installation, fencing, and lighting — we manage the complete project from start to finish.",
  },
  {
    question: "Do you provide maintenance and after-support?",
    answer:
      "Absolutely. We offer post-installation support, maintenance guidance, and servicing to ensure long-term performance and durability of your sports surface.",
  },
];


  return (
    <>
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="bg-gradient-to-r from-green-700 via-green-600 to-green-400 bg-clip-text text-center text-transparent">
  Frequently Asked Questions
</h1>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg shadow-md hover:shadow-lg transition duration-300"
            >
              <button
                className="w-full text-left p-5 font-semibold text-lg bg-gray-100 rounded-t-lg focus:outline-none flex justify-between items-center"
                onClick={() => toggleIndex(index)}
              >
                {faq.question}
                <span className="text-gray-500">{activeIndex === index ? "−" : "+"}</span>
              </button>

              {/* Slide-down animation */}
              <div
                className={`overflow-hidden transition-all duration-500 ${
                  activeIndex === index ? "max-h-96 p-5 text-gray-700" : "max-h-0"
                }`}
              >
                {activeIndex === index && <p>{faq.answer}</p>}
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default FAQ;
